import Swiper from 'swiper';
import 'swiper/css';
import { Thumbs } from 'swiper/modules';

export default class ProductDetailHeader {
    constructor() {
        this.section = document.querySelector('.component-product-detail-header');
        this.sliderProducts = this.section.querySelector('.swiper.swiper-products');
        this.sliderThumbs = this.section.querySelector('.swiper.swiper-thumbs');

        this.sliders();
    }

    sliders() {
        const sliderThumbs = new Swiper(this.sliderThumbs, {
            modules: [Thumbs],
            slidesPerView: 3,
            spaceBetween: 16,
            watchSlidesProgress: true,
            watchOverflow: true,
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                    direction: 'vertical',
                },
            },
        });

        const sliderProducts = new Swiper(this.sliderProducts, {
            modules: [Thumbs],
            spaceBetween: 10,
            thumbs: {
                swiper: sliderThumbs,
            },
        });

        let litersButton = this.section.querySelectorAll('#liter-buttons button');

        if (litersButton) {
            litersButton.forEach(button => {
                litersButton[0].dataset.active = 'true';
    
                button.addEventListener('click', () => {
                    litersButton.forEach(btn => {
                        btn.dataset.active = 'false';
                    });
                    button.dataset.active = 'true';
    
                    const targetSliderIndex = parseInt(button.dataset.slider, 10);
                    if (!isNaN(targetSliderIndex)) {
                        sliderProducts.slideTo(targetSliderIndex);
                    }
                });
            });
        }
    }
}

if (document.querySelector('.component-product-detail-header')) {
    new ProductDetailHeader();
}
